export const TEST_ID = {
  OVERVIEW_TAB_MORE_DETAILS_CONTENT: 'listing__more-details-content',
  OVERVIEW_TAB_YOUTUBE_IFRAME: 'listing__youtube-iframe',
  OVERVIEW_TAB_HERO_IMAGE: 'listing__hero-img',
  OVERVIEW_TAB_HIGHLIGHT_IMAGE: 'listing__highlight-img',
  OVERVIEW_TAB_HIGHLIGHT_SUMMARY: 'listing__highlight-summary',
  OVERVIEW_TAB_PRIVACY_AND_SECURITY: 'listing__privacy-and-security',
  OVERVIEW_TAB_INTEGRATION_DETAILS: 'listing__overview__integration-details',
  OVERVIEW_TAB_INTEGRATION_DETAILS_MODAL: 'listing__overview__integration-details--modal',
  GALLERY: 'gallery'
};
export const ELEMENT_ID = {
  APP_LISTING_TABS: 'app-listing__tabs'
};
export const ANALYTICS_EVENT_CONTAINER_OVERVIEW_TAB = 'overviewTab';
export const ANALYTICS_OVERVIEW_TRUST_CENTER_UI_LINK = 'trustCenterLink';
export const ANALYTICS_OVERVIEW_PRIVACY_POLICY_UI_LINK = 'privacyPolicyLink';
export const ANALYTICS_OVERVIEW_BUG_BOUNTY_LEARN_MORE_UI_LINK = 'bugBountyLearnMoreLink';